// Ownership is scoped to the document. Published SEO wins while mounted;
// leaving that page reveals the current tenant fallback, then the app baseline.
const documents = new WeakMap();

function claim(kind, initialTitle) {
  const target = document;
  let state = documents.get(target);
  if (!state) {
    state = { baseline: target.title, fallback: new Map(), published: new Map() };
    documents.set(target, state);
  }
  const owner = Symbol(kind);
  const owners = state[kind];
  const apply = () => {
    const published = [...state.published.values()];
    const fallback = [...state.fallback.values()];
    target.title = published[published.length - 1] ?? fallback[fallback.length - 1] ?? state.baseline;
  };
  owners.set(owner, typeof initialTitle === 'string' ? initialTitle : state.baseline);
  apply();
  return {
    baseline: state.baseline,
    update(value) {
      if (!owners.has(owner)) return;
      owners.set(owner, typeof value === 'string' ? value : state.baseline);
      apply();
    },
    release() {
      if (!owners.delete(owner)) return;
      apply();
      if (!state.fallback.size && !state.published.size) documents.delete(target);
    },
  };
}

export const claimTenantTitle = title => claim('fallback', title);
export const claimPublishedTitle = title => claim('published', title);
